import React, {useState, useEffect, act} from 'react';
import { getCurrentChild } from 'src/shared/redux-state/src';
import { useAppDispatch, useAppSelector } from 'src/app/services/store';
import { ChildrenStoreData, Observation } from 'src/shared/types/src';
import { fetchLastObservationDetails } from 'src/shared/services/src';
import { updateRefreshLastObservation } from 'src/shared/redux-state/src/lib/misc/MiscHandler';
import { getHardRefreshLastObservation } from 'src/shared/redux-state/src/lib/misc/MiscSelector';
import BaseCard from 'src/app/components/commonComponents/BaseCard';
import ObservationCardInternalDetails from 'src/app/components/ObservationCardInternalDetails';
import { LatestObservationLoader } from 'src/app/components';
import { useNavigate } from "react-router-dom";
import { AppRoutes } from 'src/app/navigation/routes';
import { ACTIVITY_TYPE } from 'src/shared/config/src';
import { getQueryString, scrollToTop } from 'src/app/utilities/helpers';


const LastObservationCard = () => {

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [observationDetails, setObservationDetails] = useState<Observation>();

    const refreshOnAddObservation = useAppSelector(getHardRefreshLastObservation);

    useEffect(() => {
        getData(currentChild);
    }, [currentChild.childInstanceKey]);

    useEffect(() => {
        if (refreshOnAddObservation) {
            getData(currentChild);
            dispatch(updateRefreshLastObservation({ refresh: false }));
        }
    }, [refreshOnAddObservation]);

    const getData = async (currentChildLocal: ChildrenStoreData) => {
        try {
            setLoading(true);
            const response = await fetchLastObservationDetails({ child: currentChildLocal });
            console.log("response from LAST OBSERVATION api : ", JSON.stringify(response));
            if (response && Object.keys(response).length > 0) {
                setObservationDetails(response.observation);
            } else {
                setObservationDetails(undefined);
            }
            scrollToTop();
        } catch (error) {
            console.log("error from LAST OBSERVATION api : ", (error as any).response);
            setObservationDetails(undefined);
        } finally {
            setLoading(false);
        }
    }

    const onLatestObservationCardPress = () => {
        const query =  getQueryString({
            activityType: [ACTIVITY_TYPE.OBSERVATION]
        });
        navigate(`${AppRoutes.TIMELINE}?${query}`);
    };

    return (
        <>
        {isLoading ? 
            <BaseCard>
                <LatestObservationLoader />
            </BaseCard> :
            <>
            {observationDetails ? 
                    <BaseCard clickable={true} onPressFunc={onLatestObservationCardPress}>
                    <ObservationCardInternalDetails details={observationDetails} title={'Latest Observation'} isHomeScreenCard={true}/>
                </BaseCard>
            : null}
            </>
        }
        </>
    )
}

export default LastObservationCard;